<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<div style="overflow:auto !important;height: 90vh;">
			<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
				<FormItem prop="trackName" label="充电站:" :label-width="100">
					<Select filterable placeholder="站点列表" style="width: 200px;" v-model="formInline.StationId">
						<Option :value=0>全部</Option>
						<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
						<span slot="prepend">充电站</span>
					</Select>
				</FormItem>
				<FormItem prop="trackName" label="设备编号:" :label-width="100">
					<Input type="text" v-model="formInline.EquipmentNo" placeholder="设备编号" />
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
				</FormItem>
			</Form>

			<template v-for="(statusItem, idx) in statusList">
				<div :key="idx" style="margin-bottom: 20px; text-align: left;">
					<Tag slot="title" class="label" :color="statusItem.color" type="dot">{{statusItem.statusDesc}}({{statusItem.statusDataTotal.length}})</Tag>
					<Row :gutter="12" type="flex" justify="start" class="chargeCardClass">
						<Col :xs="12" :sm="12" :md="12" :lg="12" :xl="8" :xxl="6" v-bind:key="item.EquipNo"
							v-for="(item) in statusItem.statusData">
						<Card :class="titleColor(item.WorkStatus)">
							<p slot="title">
								<span style="font-size: 0.46875rem;">
									{{item.LockNo}}{{item.LockName==''?'':'/'}}{{item.LockName}}</span>
							</p>
							<a style="color: #000000;font-size: 0.46875rem;" href="#" slot="extra"
								@click.prevent="detail(item.LockNo,item.WorkStatus)">
								<Icon type="ios-browsers-outline" size="24" color="white" />
							</a>
							<div class="freeDiv"
								style="text-align: center;height: 100px;display:flex; flex-direction: row; justify-content:center;">
								<div class="cicle_p circle-div" style="width: 22%;">
									<i-circle :percent="100" :size="72" :stroke-color="circleColor(item.WorkStatus)"
										:stroke-width="8" :trail-width="8">
										<p :style="circleTextColor(item.WorkStatus)">{{item.WorkStatusDesc}}</p>
									</i-circle>
								</div>
								<div class="statusCard"
									style="width: 78%;float: right;font-size: 20px;height: 100px; line-height: 100px; padding: 0px 10px;">
									<Row style="text-align: left;">
										<Col span="24" v-if="item.WorkStatus==0">
										<div>地锁状态：{{item.LockStatusDesc}}</div>
										</Col>
									</Row>
									<Row style="text-align: left;">
										<Col span="24" v-if="item.WorkStatus==-1">
										<div>离线时间：{{item.OfflineTime}}</div>
										</Col>
									</Row>
								</div>
							</div>
						</Card>
						</Col>
					</Row>
					<Button type="dashed" long v-on:click="showMore(idx)" :disabled="isAllShowed(idx)">{{ statusItem.statusData.length == statusItem.statusDataTotal.length ? '已加载全部' : '加载更多' }} </Button>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
	import echarts1 from "../../../js/echarts_hot.js";
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js';

	export default {
		data() {
			//自定义表单验证
			const latlng = (rule, value, callback) => {
				var latreg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/;

				if (!latreg.test(value)) {
					callback(new Error("请填写正确经纬度格式"));
				} else {
					callback();
				}
			};
			return {
				// getParkingLockStatusBaseUrl: webapi.base_api_url + '/Operations/GetParkingLockStatusBase',
				Control: {},
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				//详情model
				showModel: false,
				//model中两个table显示
				tableShow: true,
				tableHeight: "650",
				//充电设备总计
				BreadcrumbList: ['场站监控', '>>', '地锁状态'],
				formInline: {
					StationId: 0,
					EquipmentNo: ''
				},
				statusList: [{
					statusDesc: '空闲',
					color: '#19be6b',
					statusData: [],
					statusDataTotal: [],
					showNum: 20,
				}, {
					statusDesc: '故障',
					color: '#ed4e4c',
					statusData: [],
					statusDataTotal: [],
					showNum: 20,
				}, {
					statusDesc: '离线',
					color: 'default',
					statusData: [],
					statusDataTotal: [],
					showNum: 20,
				}],
				timer: ''
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 300;
			window.addEventListener('resize', this.getTableHeight)
		},
		activated() {
			this.timer = setInterval(this.handleSubmit, 30000);
		},
		deactivated() {
			if (this.timer) {
				clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
			}
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		updated() {},
		mounted() {
			const _this = this;
			this.$nextTick(function() {
				// 仅在整个视图都被渲染之后才会运行的代码
				// setTimeout(() => {
				// 	if (_this.StationList) _this.formInline.StationId = _this.StationList[0].StationId;
				_this.handleSubmit();
				// }, 1000);
			})
			//_this.getButton()
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
			}
		},
		computed: {
			getCircleSize: function() {
				//console.log(document.body.clientWidth / 60 + 'px')
				return document.body.clientWidth / 12
			},
			pageParam: function() {
				const _this = this;
				const param = _this.formInline
				return param
			},
			//直接选属性
			...mapState({
				StationList: 'Stations',
			}),
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				//this.$refs.sonPage.getList();
				const _this = this
				const params = _this.formInline;
				_this.$axios.post(webapi.base_api_url + '/Operations/GetParkingLockStatus', params).then(res => {
					if (res.data.code != 1) {
						_this.statusList[0].statusDataTotal = _this.dataStandby = res.data.Data.List.filter(
							function(currentValue, indedx, arr) {
								return currentValue.WorkStatus != 2 && currentValue.WorkStatus != 6 &&
									currentValue.WorkStatus != -1;
							});
						_this.statusList[0].statusData = _this.statusList[0].statusDataTotal.slice(0, Math.min(_this.statusList[0].showNum, _this.statusList[0].statusDataTotal.length));
						_this.statusList[1].statusDataTotal = _this.dataFault = res.data.Data.List.filter(function(
							currentValue, indedx, arr) {
							return currentValue.WorkStatus == 6;
						})
						_this.statusList[1].statusData = _this.statusList[1].statusDataTotal.slice(0, Math.min(_this.statusList[1].showNum, _this.statusList[1].statusDataTotal.length));
						_this.statusList[2].statusDataTotal = _this.dataOffline = res.data.Data.List.filter(
							function(currentValue, indedx, arr) {
								return currentValue.WorkStatus == -1;
							})
						_this.statusList[2].statusData = _this.statusList[2].statusDataTotal.slice(0, Math.min(_this.statusList[2].showNum, _this.statusList[2].statusDataTotal.length));
					}
				})
			},
			showMore(idx) {
				const _this = this;
				_this.statusList[idx].showNum += 20;
				_this.statusList[idx].statusData = _this.statusList[idx].statusDataTotal.slice(0, Math.min(_this.statusList[idx].showNum, _this.statusList[idx].statusDataTotal.length));
			},
			isAllShowed(idx) {
				const _this = this;
				return _this.statusList[idx].statusData.length == _this.statusList[idx].statusDataTotal.length;
			},
			// detail: function(ConnectorNo, WorkStatus) {
			// 	const _this = this
			// 	const params = {
			// 		ConnectorNo: ConnectorNo
			// 	}
			// 	_this.$axios.post(webapi.base_api_url + '/Operations/GetEqumentStatusDetail', params).then(res => {
			// 		if (res.data.code != 1) {
			// 			_this.dataDetail = [];
			// 			_this.dataDetail.push(res.data.Data.Detail);
			// 		}
			// 	})
			// 	//充电中才会显示订单详情table
			// 	if (WorkStatus == 2) {
			// 		_this.tableShow = true
			// 	} else {
			// 		_this.tableShow = false
			// 	}
			// 	_this.showModel = true
			// },
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 300;
			},
			titleColor: function(WorkStatus) {
				let titleClass = '';
				switch (WorkStatus) {
					case 0:
						titleClass = "free cardTitleGreen"
						break;
					case 1:
						titleClass = "free cardTitleBlue"
						break;
					case 2:
						titleClass = "free cardTitleBlue"
						break;
					case 6:
						titleClass = "free cardTitleRed"
						break;
					case -1:
						titleClass = "free cardTitleGrey"
						break;
					default:
						titleClass = "free cardTitleGreen"
						break;
				}
				return titleClass;
			},
			circleColor: function(WorkStatus) {
				let titleClass = '';
				switch (WorkStatus) {
					case 0:
						titleClass = "#19be6b"
						break;
					case 1:
						titleClass = "#2d8cf0"
						break;
					case 2:
						titleClass = "#2d8cf0"
						break;
					case 6:
						titleClass = "#ed4e4c"
						break;
					case -1:
						titleClass = "#d8dee6"
						break;
					default:
						titleClass = "#19be6b"
						break;
				}
				return titleClass;
			},
			circleTextColor: function(WorkStatus) {
				let titleClass = '';
				switch (WorkStatus) {
					case 0:
						titleClass = "color:#19be6b"
						break;
					case 1:
						titleClass = "color:#2d8cf0"
						break;
					case 2:
						titleClass = "color:#2d8cf0"
						break;
					case 6:
						titleClass = "color:#ed4e4c"
						break;
					case -1:
						titleClass = "color:#d8dee6"
						break;
					default:
						titleClass = "color:#19be6b"
						break;
				}
				return titleClass;
			},
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.normal {
		margin-bottom: 20px;
		box-shadow: 2px 2px 4px #a7a7a7;
		width: 90% !important;
		height: 160px;
		background-image: linear-gradient(#ffffff, #eeeeee);
		font-size: 6px;
	}

	.normal .ivu-card-head {
		background-image: linear-gradient(#3FD983, #3aca79);
	}

	.normal .ivu-card-body {
		padding: 0px 10px;
	}

	.free {
		margin-bottom: 12px;
		box-shadow: 2px 2px 4px #a7a7a7;
		/* width: 90% !important; */
		height: 150px;
		background-image: linear-gradient(#ffffff, #eeeeee);
		font-size: 6px;
	}

	.free .ivu-card-body {
		padding: 0px 10px;
	}

	.cardTitleBlue .ivu-card-head {
		background-image: linear-gradient(#55aaff, #4d9ae7);
	}

	.cardTitleRed .ivu-card-head {
		background-image: linear-gradient(#ed4e4c, #ed4e4c);
	}

	.cardTitleGrey .ivu-card-head {
		background-image: linear-gradient(#e8eaec, #e8eaec);
	}

	.cardTitleGreen .ivu-card-head {
		background-image: linear-gradient(#19be6b, #19be6b);
	}

	.ivu-card-head p {
		text-align: left;
		color: white;
	}

	.freeDiv .ivu-chart-circle-inner {
		/* top: 1.1875rem; */
	}

	.ivu-chart-circle-inner p {
		font-size: 0.46875rem;
	}

	.statusCard span {
		font-size: 0.3125rem;
	}

	.chargeCardClass .ivu-col-span-7 {
		margin-left: 0px;
	}

	.ivu-chart-circle {
		/* width: 2.8125rem !important; */
		/* height: 2.8125rem !important; */
	}

	.circle-div {
		float: left;
		height: 100%;
		padding: 10px 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.tag {
		background-color: #2d8cf0;
		padding: 0px 2px 0px 2px;
		border-radius: 2px;
	}

	.label {
		background: transparent !important;
		padding-left: 0;
	}

	.label .ivu-tag-dot-inner {
		margin-right: 0;
		height: 15px;
		width: 15px;
	}

	.label .ivu-tag-text {
		font-size: 20px;
	}

	.loginBg .ivu-card-bordered,
	.ivu-card {
		margin-right: 0;
	}
</style>
